export default __webpack_public_path__ + "static/media/EM0400.34I-22654_-15117_0.be8af1ef.jpg";